import { Button,AlertDialogFooter,AlertDialogBody,AlertDialogHeader,AlertDialogContent,AlertDialogOverlay
,useDisclosure,AlertDialog,useToast} from "@chakra-ui/react"

import React from "react"
import { signinfailed, signinsucccess, usersignin } from '../Reducer/Login/action';
import { useContext } from "react"
import { useNavigate,useLocation } from "react-router-dom"
import { Authcontext } from "../AuthProvider.jsx/AuthProvider"
import { useDispatch,useSelector } from "react-redux"
import { removetoken } from "../Reducer/Login/action"

export default function Logout() {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = React.useRef()
const dispatch=useDispatch()
const userdata=useSelector((state)=>{

  return state.loginreducer
})
const {username}=userdata
let obj={
  "name":""
}
  // console.log(username)
  const navigate=useNavigate()
  const toast=useToast()
  const location=useLocation()
    return (
      <>
        <Button isDisabled={!username&&true} colorScheme='red' onClick={onOpen}>
          Log Out
        </Button>
  
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Log Out
              </AlertDialogHeader>
  
              <AlertDialogBody>
              Are you sure ,You want to log out??
              </AlertDialogBody>
  
              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose}
                 >
                  Cancel
                </Button>
                <Button  colorScheme='red' onClick={()=>{
                  
           
                 
                  
                    onClose()
                    toast({description:"Logout successfully","position":"top",status:"success"})
                    dispatch(removetoken())
                    navigate("/")
                  
                    
                    }} ml={3}>
                  Delete
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </>
    )
  }